<template>
	<div class="fixed left-0 right-0 bottom-0 top-0 flex items-center justify-center z-50 bg-semi-transparent-black">
		<DefaultCard class="max-w-md">
			<Heading class="text-center mb-8">
				<slot name="heading">Loading</slot>
			</Heading>
			<Spinner orange class="mx-auto"></Spinner>
		</DefaultCard>
	</div>
</template>

<script>
    import DefaultCard from "./layout/DefaultCard";
	import Heading from "./Heading";
	import Spinner from "./Spinner";
	export default {
        name: "LoadingOverlay",
		components: {Spinner, Heading, DefaultCard}
	}
</script>

<style scoped>

</style>
